import React from 'react';
import theme from "../../../theme/SuralinkTheme";
import { Typography } from '@material-ui/core';
import classnames from 'classnames';
import classes from "./BadgeLabel.module.scss";

interface BadgeLabelProps {
	label?: string;
	color?: string;
    size?: "default" | "large";
    icon?: any;
    className?: string;
}

const BadgeLabel: React.FC<BadgeLabelProps> = ({ 
	label,
	color,
    size,
    icon,
    className:propsClassName,
 }) => {

  return (
    <div style={{backgroundColor: color || theme.palette.grey[300]}} className={classnames(size === "default" ? classes.defaultBadge : classes.largeBadge, propsClassName)}>
        {icon}
        <Typography variant="subtitle2" style={{color: theme.palette.grey[900]}}>
            {label}
        </Typography>
    </div>
  )
}
export default BadgeLabel;
